import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useEffect } from 'react';
import { useLocalizeMessage, Table, Badge, H5, Text } from 'libs.nucleus';
import { getStatusBadgeVariant, getStatusLabel } from '../../utils';
export const CloneChartSelect = ({ charts, isLoading, selectedChartId, onChartSelect }) => {
    const translate = useLocalizeMessage();
    // Filter to only show charts that can be cloned (non-archived, Ready status)
    const cloneableCharts = useMemo(() => charts.filter((chart) => chart.active !== false && chart.status === 'PUBLISHED'), [charts]);
    const columns = useMemo(() => [
        {
            header: translate('Name'),
            accessorKey: 'name',
            cell: ({ row }) => (_jsx(Text, { size: 'sm', className: 'text-primary-500 font-medium', children: row.original.name })),
        },
        {
            header: translate('Description'),
            accessorKey: 'description',
            accessorFn: (row) => row.metadata?.description || '',
        },
        {
            header: translate('Version'),
            accessorKey: 'version',
            cell: ({ row }) => _jsx(Badge, { label: `V${row.original.version}` }),
        },
        {
            header: translate('Status'),
            accessorKey: 'status',
            cell: ({ row }) => {
                const { status } = row.original;
                return _jsx(Badge, { label: getStatusLabel(status, translate), variant: getStatusBadgeVariant(status) });
            },
        },
    ], [translate]);
    // Reset selection if selected chart is no longer in the list
    useEffect(() => {
        if (selectedChartId && !cloneableCharts.find((c) => c.id === selectedChartId)) {
            onChartSelect(null);
        }
    }, [cloneableCharts, selectedChartId, onChartSelect]);
    const emptyStateMessage = useMemo(() => {
        if (charts.length === 0) {
            return translate('No charts available for cloning. Go back and create one manually to get started.');
        }
        return translate('No charts found matching your search.');
    }, [charts.length, translate]);
    return (_jsxs("div", { className: 'flex flex-col size-full p-4', children: [_jsx(H5, { className: 'mb-4', children: translate('Select the chart you want to clone') }), _jsx(Table, { columns: columns, data: cloneableCharts, isLoading: isLoading, hasPagination: true, initialPageSize: 10, paginationNavigationScreenReaderLabel: translate('Pagination navigation'), isSelectable: true, isSingleSelect: true, getRowId: (row) => row.id, selectedIds: selectedChartId ? [selectedChartId] : undefined, onRowSelectionChange: (ids) => onChartSelect(ids[0] || null), useInternalSearch: true, labelNoResults: emptyStateMessage })] }));
};
